import React, { useState } from "react";
import { Typography, Box, TextField, Chip, Button } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import BulkUpdateDialog from "../../../../components/BulkUpdateDialog";
import AddIcon from "@mui/icons-material/Add";
import {
  AccordionDetailsStyled,
  AccordionStyled,
  AccordionSummaryStyled,
} from "app/pages/components/mui/Accordions/StyledAccordion/StyleAccordion";

const TagsAccordion = ({
  expanded,
  onChange,
  tagInput,
  setTagInput,
  problemTags,
  handleAddTag,
  handleDeleteTag,
  setProblemTags,
}) => {
  const [openDialog, setOpenDialog] = useState(false);

  const validateTags = (parsedTags) => {
    parsedTags.forEach((tag, index) => {
      if (!tag.name) {
        throw new Error(`Tag at index ${index} is missing name`);
      }
      if (!tag.id && tag.id !== 0) {
        throw new Error(`Tag at index ${index} is missing id`);
      }
    });
  };

  const handleBulkUpdateTags = (parsedTags) => {
    // Directly update problemTags with the parsed tags
    setProblemTags((prevTags) => [
      ...prevTags,
      ...parsedTags.map((tag) => ({
        id: tag.id,
        name: tag.name,
      })),
    ]);
  };

  return (
    <>
      <AccordionStyled expanded={expanded} onChange={onChange}>
        <AccordionSummaryStyled expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1">Tags</Typography>
          {expanded && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenDialog(true);
                }}
              >
                Bulk Update
              </Button>
            </Box>
          )}
        </AccordionSummaryStyled>
        <AccordionDetailsStyled>
          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <TextField
              label="Add Tag"
              value={tagInput}
              onChange={(e) => setTagInput(e.target.value)}
              onKeyPress={handleAddTag}
              sx={{ flex: 1, maxWidth: "200px" }}
            />
          </Box>
          {problemTags.map((tag) => (
            <Chip
              key={tag.id}
              label={tag.name}
              onDelete={() => handleDeleteTag(tag.id)}
              variant="outlined"
              sx={{ m: 0.5 }}
            />
          ))}
        </AccordionDetailsStyled>
      </AccordionStyled>

      <BulkUpdateDialog
        title="Bulk Update Tags"
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onBulkUpdate={handleBulkUpdateTags}
        validateInput={validateTags}
        successMessage="Tags added successfully!"
        helperText="Enter an array of tags in JSON format (e.g., [{ 'id': 1, 'name': 'Tag 1' }])"
      />
    </>
  );
};

export default TagsAccordion;
